// Fix any style issues and re-enable lint.
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import {StandardDNACodon} from 'biojs/Codons';
import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';

import * as OrganismDAO from './OrganismDAO';

const OrganismActions = {
  getCodonUsage(organismId: number) {
    OrganismDAO.getCodonUsage(organismId)
      .done(({data}: {data: Record<StandardDNACodon, number>}) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.ORGANISM_CODON_USAGE_FETCH,
          organismId,
          codonUsage: data,
        });
      })
      .fail(notifications.notifyError);
  },
};

export default OrganismActions;
